// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.portalanalytics.enums.AnalyticsSearchType

export enum AnalyticsSearchType {
  CUSTOMER = 'CUSTOMER',
  LISTING_ALIAS = 'LISTING_ALIAS',
  PRODUCT_TYPE = 'PRODUCT_TYPE',
  USER_MANAGEMENT_COMPANY = 'USER_MANAGEMENT_COMPANY',
  ZRN_NUMBER = 'ZRN_NUMBER',
  ZUID = 'ZUID',
}

export const AnalyticsSearchType_values = [
  AnalyticsSearchType.CUSTOMER,
  AnalyticsSearchType.LISTING_ALIAS,
  AnalyticsSearchType.PRODUCT_TYPE,
  AnalyticsSearchType.USER_MANAGEMENT_COMPANY,
  AnalyticsSearchType.ZRN_NUMBER,
  AnalyticsSearchType.ZUID,
] as const;
